import React, { Component } from "react";
import Helmet from "react-helmet";
import config from "../../data/SiteConfig";
import "./styles/contact.css";
import Jumbotron from "../components/Jumbotron/Jumbotron";

class ContactPage extends Component {
  render() {
    return (
      <div className="ContactPage">
        <Helmet title={`Contact | ${config.siteTitle}`} />
        <Jumbotron message="Contact Us" />
        <div className="ContactPage__content Container">
          <p>
            <b>Terribly Sorry Studios</b><br/>
            20 Camden Street<br/>
            Suite 200<br/>
            Toronto, ON<br/>
            M5V 1V1<br/>
            Canada
          </p>
          <p>
            info@sorrystudios.com<br/>
          </p>
          <p>
            1 (855) 699-3825<br/>
          </p>
          <p>
            1 (647) 493-3825<br/>
          </p>
        </div>
      </div>
    );
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx